import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import axios from 'axios'
import { message } from 'antd'
import * as qs from 'qs'
import Cookies from 'js-cookie'
import env from '@env'

const ENVCONFIG = env

let isShowingMsg = false

const errorHandler = (error: any) => {
  const { response } = error

  if (!response || !Object.keys(response).length) {
    return showErrorMsg('网络异常，请稍后再试')
  }

  switch (Number(response.data.code)) {
    case 401:
      showErrorMsg(`请登录`)
      if (ENVCONFIG.env !== 'dev') {
        setTimeout(() => (window.location.href = ENVCONFIG.loginPage), 1000)
      }
      return Promise.reject(response)
    case 403:
      showErrorMsg(`登录过期，请重新登录`)
      if (ENVCONFIG.env !== 'dev') {
        setTimeout(() => (window.location.href = ENVCONFIG.loginPage), 1000)
      }
      return Promise.reject(response)
    default:
      if (response.data.status_code === 404) {
        // showErrorMsg(response.data.message)
      } else {
        showErrorMsg(
          `服务器繁忙，请稍后再试${response.data.status_code}${response.data.message}`,
        )
      }
      return Promise.reject(response)
  }
}

const showErrorMsg = (msg, hideTime = 2) => {
  if (!isShowingMsg) {
    isShowingMsg = true
    message.error(msg, hideTime, () => {
      isShowingMsg = false
    })
  }
}

const methods = ['get', 'post', 'put', 'delete']

const http: HttpResquest = {}

methods.forEach(method => {
  http[method] = (
    url: string,
    data: PlainObject,
    options?: HttpRequestOptions,
  ): Promise<IHttpResponse | PlainObject> => {
    const opts: HttpRequestOptions = Object.assign(
      {
        baseUrl: ENVCONFIG.apiUrlPrefix, // 默认apiUrl前缀使用环境配置，特殊接口可以通过httpRequestOptions覆盖
        formatResponse: true,
      },
      {
        structure: 'data:nested', // 返回的数据结构，默认为 response.data.data，还有 primitive-response 和 data-reponse.data
        showMsg: true, // 控制错误信息展示的开关
        ...options,
      },
    )

    const axiosConfig: AxiosRequestConfig = {
      method,
      url,
      baseURL: opts.baseUrl,
      withCredentials: true, // 如果不需要带cookie请求， 请注释
    }

    const requestInstance = axios.create()

    // POST传参序列化(添加请求拦截器)
    requestInstance.interceptors.request.use(
      config => {
        const ts = Date.now() / 1000
        if (config.params && !config.params.noLoading) {
          NProgress.start()
        }
        config.params = Object.assign({}, config.params, {
          ts,
          token: Cookies.get('AUTHOR_TOKEN'),
          project: 'soft',
        })
        return config
      },
      error => {
        NProgress.done()
        return Promise.reject(error)
      },
    )

    // 返回状态判断(添加响应拦截器)
    requestInstance.interceptors.response.use(
      res => {
        NProgress.done()
        if (res.data && res.data.code > 300) {
          errorHandler({ response: res })
        }

        return res
      },
      error => {
        NProgress.done()
        errorHandler(error)
        return Promise.reject(error)
      },
    )

    // 参数传递方式
    if (method === 'get') {
      axiosConfig.params = data
    } else if (data instanceof FormData) {
      axiosConfig.data = data
    } else {
      axiosConfig.data = qs.stringify(data)
    }

    return requestInstance
      .request(axiosConfig)
      .then(response => {
        switch (opts.structure) {
          case 'data':
            return Promise.resolve(response.data)
          case 'data:nested':
            return Promise.resolve(response.data.data)
          case 'primitive':
            return Promise.resolve(response)
        }
      })
      .catch((err: IHttpError) => {
        return Promise.reject(err)
      })
  }
})

export default http
